import NavigationService from "@/services/NavigationService";

const elementorHeaderButtonSelector = '.elementor-element-325ab64';

interface ElementorHeaderButtonContent {
    url: string,
    title: string,
    subtitle: string,
}

let originalElementorHeaderButtonContent: ElementorHeaderButtonContent|false = false;

export function performLoginDomChanges() {
    document.body.classList.remove('bf-logged-out');
    document.body.classList.add('bf-logged-in');

    originalElementorHeaderButtonContent = updateElementorHeaderButton({
        url: NavigationService.buildRouteUrl('userProfile'),
        title: 'Mein Konto',
        subtitle: 'Profil, Kurse & mehr'
    });
}

export function performLogoutDomChanges() {
    document.body.classList.remove('bf-logged-in');
    document.body.classList.add('bf-logged-out');

    if( !originalElementorHeaderButtonContent ) {
        return;
    }
    updateElementorHeaderButton(originalElementorHeaderButtonContent);
}

/**
 * Sets new content and returns previous content.
 * @param newContent
 * @return ElementorHeaderButtonContent
 */
function updateElementorHeaderButton(newContent: ElementorHeaderButtonContent) : ElementorHeaderButtonContent | false {
    const button = getElementorHeaderButtonElement();
    if( !button ) {
        return false;
    }

    const elements = {
        linkEl: button.querySelector('.pp-info-box-container'),
        titleEl: button.querySelector('.pp-info-box-title'),
        subtitleEl: button.querySelector('.pp-info-box-subtitle'),
    }

    if( !elements.linkEl || !elements.titleEl ) {
        console.warn(`elementor header button present, but has no link url or title content`, button);
        return false;
    }

    const oldContent: ElementorHeaderButtonContent = {
        url: elements.linkEl.getAttribute('href') || '',
        title: elements.titleEl.textContent || '',
        subtitle: elements.subtitleEl?.textContent || '',
    };

    elements.linkEl.setAttribute('href', newContent.url);
    elements.titleEl.textContent = newContent.title;
    if( elements.subtitleEl ) {
        elements.subtitleEl.textContent = newContent.subtitle;
    }

    return oldContent;
}

function getElementorHeaderButtonElement() : Element|undefined {
    const button = document.querySelector(elementorHeaderButtonSelector);

    if( !button ) {
        console.warn(`no elementor header button present, tried selector "${elementorHeaderButtonSelector}"`);
        return undefined;
    }

    return button;
}
